import React from 'react';
import Classnames from 'classnames';

import './style.css';

export default class Dialog extends React.Component {
  state = { value: '' };

  componentWillMount() {
    this.setState({ value: this.props.prompt || '' });
  }

  componentDidMount() {
    const node = this.refs[Object.keys(this.refs)[0]];
    if(node){
      node.focus();
      node.select && node.select();
    }
  }

  render() {
    const { message, buttons, prompt, onSelect, wide } = this.props;
    const { value } = this.state;

    return (
      <div className={"dialog " + (wide ? "wide" : "")}>
        {message}

        {prompt === undefined
          ? null
          : <input
              type="text"
              ref="input"
              value={value}
              onChange={event => this.setState({ value: event.target.value })}
              onKeyPress={event => {
                if (event.key === 'Enter') {
                  const button = buttons.filter(d => d.callback)[0];
                  button && onSelect(button.callback, value);
                }
              }}
            />}

        <div className="buttons">
          {buttons.map((button, i) => (
            <button
              key={button.label}
              ref={`button-${i}`}
              className={Classnames({ efficacious: !!button.callback })}
              onClick={() => onSelect(button.callback, value)}
            >
              {button.label}
            </button>
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dialog/index.js